import Vue from "vue";

export const store = Vue.observable({
  token: localStorage.getItem("token"),
  queryToken: localStorage.getItem("queryToken"),
  role: localStorage.getItem("role"),
  email: localStorage.getItem("email"),
});

export const mutations = {
  setToken(token) {
    store.token = token;
    localStorage.setItem("token", token)
  },
  setQueryToken(token) {
    store.queryToken = token;
    localStorage.setItem("queryToken", token)
  },
  setRole(role) {
    store.role = role;
    localStorage.setItem("role", role)
  },
  setEmail(email) {
    store.email = email;
    localStorage.setItem("email", email)
  },
  logout() {
    store.email = null;
    localStorage.removeItem('email');
    store.role = null;
    localStorage.removeItem('role');
    store.token = null;
    localStorage.removeItem('token');
  }  
};